<template>
  <div>
    <el-dialog @open="openFun" title="绑定账户手机号验证" :close-on-click-modal="false" label-position="left" :visible.sync="isShow" width="450px" :before-close="handleClose">
      <div class="content">
        <div class="content-l">
          <div class="labels">提现金额</div>
          <div class="number">
            <div class="number-text">{{ priceNum }} 元</div>
          </div>
        </div>
        <div class="content-l">
          <div class="labels">提现账户</div>
          <div class="number">
            <div class="number-text">{{ account }}</div>
          </div>
        </div>
        <div class="content-l">
          <div class="labels">手机号码</div>
          <div class="number">
            <div class="number-text">{{ phoneNumber }}</div>
            <div class="number-title">默认注册绑定的号码，如有变更请联系客服更换。</div>
          </div>
        </div>
        <div class="content-r">
          <div class="labels">验证码</div>
          <div class="code">
            <!-- <div class="code-top">
              <el-input width="200px" maxlength="6" class="btns" v-model="code" placeholder="输入验证码">
              </el-input>
              <el-button @click="getIdentifyCodeBtn" :disabled="isDisabledCode" class="handelCode" type="warning">{{ isDisabledCode ? count + '秒重新获取' : '获取验证码'  }}</el-button>
            </div> -->

            <div class="code-top-two">
              <el-input width="400px" maxlength="6" class="btns-two" v-model="code" placeholder="输入验证码">
                
              </el-input>
              <div @click="getIdentifyCodeBtn" class="code-top-two-btn" :style="{'cursor':isDisabledCode ? 'not-allowed' : 'pointer'}">{{ isDisabledCode ? count + '秒重新获取' : '获取验证码'  }}</div>
            </div>

            <div class="code-title">验证码有效时间为5分钟。</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <button :disabled="isDisabled">确定</button>
        <button>取消</button> -->
        <el-button @click="btnsSucces" :type="isDisabled ? 'info': 'warning' " class="btnsss" :disabled="isDisabled">确 定</el-button>
        <el-button @click="closeDialog" class="set-other-btn">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mini from "@/api/mini";
import debounce from '@/utils/debounce.js'
const MiniModel = new mini()
export default {
  name: "PhoneVerification",
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    // 1账户中心提交 2小程序提交 3公众号提交
    types:{
      type:String,
      default:'0'
    },
    priceNum:{
      type: String,
      default: 0
    },
    account:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      phone: '', //不带星号
      phoneNumber: '', //带星号
      dialogFormVisible: false,
      code: "", //验证码
      isDisabled: true, //确定按钮
      isDisabledCode: false,
      count:119,
      timeouts:0,
    }
  },
  created: function () {
    var phone = this.$store.getters.curentPhoneNumber.toString()
    console.log(phone,'绑定的手机号码')
    this.phone = this.$store.getters.curentPhoneNumber.toString()
    if(phone.length > 0) {
      // 中间带*号
      this.phoneNumber = phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
    }else{
      this.phoneNumber = ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog',false)
    },
    openFun() {
      this.code = ''
    },
    // 确定
    btnsSucces() {
      // 判断type类型提交
      debounce(() => {
        if(this.types == '1') {
          // 账户中心
          this.$emit('AccountCenter',this.code)
        }else if(this.types == '2') {
          // 小程序
          this.$emit('MiniProgram',this.code)
        }else if(this.types == '3') {
          // 公众号
          this.$emit('OfficialAccount',this.code)
        }
      },1500,true)
    },
    // 发送验证码
    getIdentifyCodeBtn() {
      debounce(() => {
        this.sendSmsCodeFun()
      },1500,true)
    },
    // 倒计时
    countTime() {
      const TIME_OUT = 120;
      if (!this.timer) {
        this.count = TIME_OUT;
        this.isDisabledCode = true
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_OUT) {
            this.count--;
          } else {
            this.isDisabledCode = false
            this.isDisabled = false
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 发送短信
    sendSmsCodeFun() {
      // console.log('aa')
      // return
      MiniModel.sendSmsCode().then(res => {
        console.log(res,'短信验证码')
        // 操作太频繁，请2分钟后重试
        if(res.data.code == -100) {
          this.$Message.error(res.data.message)
          return
        }
        this.$Message.success('发送成功')
        this.isDisabled = false
        this.countTime()
      }).catch(error => {
        this.isDisabled = true
        console.log(error)
        this.$Message.error('短信发送失败')
      })
    },
    // 关闭
    closeDialog() {
      this.$emit('closeDialog',false)
    },
    setIsDisabled(val) {
      console.log(val,'val')
      this.isDisabled = true
    }
  }

}
</script>

<style scoped lang="less">
.content {
  .content-l {
    display: flex;
    margin-bottom: 10px;
    .labels {
      width: 80px;
    }

    .number-text {
      margin-bottom: 10px;
    }

    .number-title {
      color: #b0afaf;
    }
  }

  .content-r {
    display: flex;

    .labels {
      width: 80px;
    }

    .code {
      .code-top {
        overflow: hidden;
        display: flex;
        width: 300px;
        .handelCode {
          // width: 200px;
          display: flex;
          // justify-content: center;
          align-items: center;
          flex: 1;
        }
      }
      .code-top-two {
        // overflow: hidden;
        // display: flex;
        width: 300px;
        position: relative;
        /deep/.el-input__inner{
          width:300px;
        }
        .code-top-two-btn{
          padding: 5px 10px;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          // cursor: pointer;
        }
        
        .handelCode {
          // width: 200px;
          display: flex;
          // justify-content: center;
          align-items: center;
          flex: 1;
        }
      }

      .code-title {
        color: #b0afaf;
        margin-top: 10px;
      }
    }
  }
}
/deep/.el-input__inner{
  width: 150px;
}
.btns {
  // color: red;
  // background-color: #ff8622;
  width: 150px;
}

/deep/.el-dialog__footer {
  display: flex;
  flex-direction: row-reverse;
  // text-align: right;
}
.set-other-btn{
  color: #2f2f2f;
  background-color: #fff;
  border-color: #eee;
}
// 鼠标悬浮
.set-other-btn:hover {
  background-color: #fff; 
  border-color: #61d7b5; 
  color: #61d7b5;
}
// 鼠标点击
.set-other-btn:focus {
  background-color: #fff; 
  border-color: #61d7b5; 
  color: #61d7b5;
}

// .dialog-footer{
//   float: right;
// }
/deep/.el-dialog__header{
  background-color: #ff8622;
  border: 1px solid #ff8622 !important;
}
/deep/.el-dialog__title{
  color: #fff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/PhoneVerification.vue